import React from 'react';
import Styles from './LogosSection.module.scss';
import { ReactComponent as Logo1 } from '../../../assets/landingpage/Mask group.svg';
import { ReactComponent as Logo2 } from '../../../assets/landingpage/mv-logo 1.svg';
import { ReactComponent as Logo3 } from '../../../assets/landingpage/Mask group (1).svg';
import { ReactComponent as Logo4 } from '../../../assets/landingpage/SiteLogo.svg';
import { ReactComponent as Logo5 } from '../../../assets/landingpage/Mask group (2).svg';
import { ReactComponent as Logo6 } from '../../../assets/landingpage/Frame.svg';
import theGarage from "./images/the_garage.png"
import adobeSummit from "./images/adobe_summit.png"

const LogosSection = () => {
  return (
    <div className={Styles.logo_container}>
      <Logo1 height={60} />
      <Logo2 height={60} />
      <Logo3 height={60} />
      <Logo4 height={60} />
      <Logo5 height={60} />
      <Logo6 height={60} />
      <img src={adobeSummit} alt="Adobe Summit" style={{maxHeight: '20px', userSelect: 'none'}} />
      <img src={theGarage} alt="The Garage" style={{maxHeight: '30px', userSelect: 'none'}} />
    </div>
  );
};

export default LogosSection;
